import React, { ChangeEvent, FormEvent, useCallback, useEffect, useState } from 'react'
import { Alert, Button, Col, Container, Form, Row } from 'react-bootstrap'
import { CustomerKyc } from '../../types';
import UserService from '../../services/user-service';
import { useAuth, User } from '../../context/auth-context';
import { formatPhoneNumber } from '../../helper/utils';
import eventBus from '../../events/event-bus';

const Settings = () => {

    const [payload, setPayload] = useState<CustomerKyc>({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        country: '',
        postalCode: '',
        confirmPassword: '',
        password: '',
        id: 0
    });
    const [errors, setErrors] = useState<string>('');
    const [message, setMessage] = useState<string>('');
    const states = (process.env.REACT_APP_STATE_DROPDOWN || "").split(",");

    const { user } = useAuth();

    const handleOnChange = useCallback((e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value, type } = e.target;

        const fieldValue = type === "checkbox" && "checked" in e.target ? (e.target as HTMLInputElement).checked : value;

        setPayload((prev) => ({ ...prev, [name]: fieldValue}));
    }, []);

    const handleKycUpdateSubmission = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (!user?.id) {
            return ;
        }

        const newPayload = {...payload, id: user.id, phone: formatPhoneNumber(payload.phone)};

        if (payload.password && payload.password.trim().length > 0 && (payload.password.trim() !== payload.confirmPassword.trim())) {
            setErrors("Password and Confirm Password did not match");
            return ;
        }

        const { status, data, message } = await UserService.updateCustomerKyc(newPayload);
        
        if (status !== 200) {
            setErrors(message);
            setMessage("");
            return ;
        }

        eventBus.dispatchEvent(new CustomEvent('kyc:updated', {detail: { user: data }}));
        setMessage(message);
        setErrors("");

        void fetchCustomerKyc(user);

    }, [user?.id, payload]);


    const fetchCustomerKyc = useCallback(async (user: User) => {

        const { status, data, message } = await UserService.getCustomerKyc(user.id);
        
        if (status !== 200) {
            setErrors(message);
            return ;
        }

        setPayload(data?.customer);

    }, []);

    useEffect(() => {

        if (!user?.id) {
            return;
        }

        void fetchCustomerKyc(user);

    }, [user?.id])

    return (
        <Container>
            <Row className='mb-2'>
                <Col xs={12} sm={7}><h4 style={{ fontSize: '1.4rem' }}>Update my Kyc</h4></Col>    
            </Row>
            <Row className='mb-4'>
                <Col xs={12} sm={5}>
                    <Form className='my-4' onSubmit={handleKycUpdateSubmission}>
                        {errors && <Alert style={{ fontSize: '.9rem' }} variant='danger'>{errors}</Alert>}
                        {message && <Alert style={{ fontSize: '.9rem' }} variant='success'>{message}</Alert>}
                        <Row>
                            <Col md={6} xs={12}>
                                <Form.Control 
                                    type='text'
                                    placeholder='First name'
                                    name='firstName'
                                    required
                                    value={payload.firstName}
                                    onChange={handleOnChange}
                                />
                            </Col>
                            <Col md={6} xs={12}>
                                <Form.Control 
                                    type='text'
                                    placeholder='Last name'
                                    name='lastName'
                                    required
                                    value={payload.lastName}
                                    onChange={handleOnChange}
                                />
                            </Col>
                        </Row>
                        <Row className='my-3'>
                            <Col md={12} xs={12}>
                                <Form.Control 
                                    type='text'
                                    placeholder='Address'
                                    name='address'
                                    required
                                    value={payload.address}
                                    onChange={handleOnChange}
                                />
                            </Col>
                        </Row>
                        <Row className='my-3'>
                            <Col md={6} xs={12}>
                                <Form.Select size='sm' className='py-2' name='country' required value={payload.country} onChange={handleOnChange}>
                                    <option value="nigeria">Nigeria</option>
                                </Form.Select>
                            </Col>
                            <Col md={6} xs={12}>
                                <Form.Select size='sm' value={payload.state} className='py-2' name='state' onChange={handleOnChange} required>
                                    <option>State</option>
                                    {states.map((state: string, i: number) => <option key={`option-${i}`} value={state}>{state}</option>)}
                                </Form.Select>
                            </Col>
                        </Row>
                        <Row className='my-3'>
                            <Col md={6} xs={12}>
                                <Form.Control 
                                    type='text'
                                    placeholder='City'
                                    name='city'
                                    required
                                    value={payload.city}
                                    onChange={handleOnChange}
                                />
                            </Col>
                            <Col md={6} xs={12}>
                                <Form.Control 
                                    type='text'
                                    placeholder='Postal Code'
                                    name='postalCode'
                                    value={payload.postalCode}
                                    onChange={handleOnChange}
                                />
                            </Col>
                        </Row>
                        <Row className='my-3'>
                            <Col md={12} xs={12}>
                                <Form.Control 
                                    type='text'
                                    placeholder='Email'
                                    name='email'
                                    required
                                    value={payload.email}
                                    onChange={handleOnChange}
                                />
                            </Col>
                        </Row>
                        <Row className='my-3'>
                            <Col md={12} xs={12}>
                                <Form.Control 
                                    type='text'
                                    placeholder='Phone number'
                                    name='phone'
                                    required
                                    value={payload.phone}
                                    onChange={handleOnChange}
                                />
                            </Col>
                        </Row>

                        <Row className='my-4'>
                            <Col md={12} xs={12}>
                                <h6>Reset Password</h6>
                                <hr className='my-2' />
                            </Col>
                            <Col md={12} xs={12}>
                                <Row className='my-3 mb-2'>
                                    <Col md={6} xs={12}>
                                        <Form.Control 
                                            type='password'
                                            placeholder='Password'
                                            name='password'
                                            value={payload.password}
                                            onChange={handleOnChange}
                                        />
                                    </Col>
                                    <Col md={6} xs={12}>
                                        <Form.Control 
                                            type='password'
                                            placeholder='Confirm Password'
                                            name='confirmPassword'
                                            value={payload.confirmPassword}
                                            onChange={handleOnChange}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className='my-1 mb-5'>
                            <Col md={12} xs={12} className='d-flex justify-content-start'>
                                <Button type='submit' variant='success' className='rounded'>Save Changes</Button>
                            </Col>
                        </Row>
                        {/* <Row className='my-4'>
                            <Col md={12} xs={12}>
                                <h6>Delete My Account</h6>
                                <p className='m-0 p-0' style={{fontSize: '.9rem'}}><small>Please note that this action is irriversible</small></p>
                                <hr className='my-2' />
                            </Col>
                            <Col md={12} xs={12}>
                                <Button type='button' variant='danger' className='rounded' size='sm'>Delete my account</Button>
                            </Col>
                        </Row> */}
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default Settings
